// extracted by mini-css-extract-plugin
module.exports = {"image":"card-icon_image__1OjvN","disabled":"card-icon_disabled__3LXh6"};